import { Controller } from '@hotwired/stimulus';
import { EVENTS as RESULTS_EVENTS } from '../prior_vote_results_component/prior_vote_results_component_controller';

const LIMIT_INCREASE = 5;

export default class extends Controller {
  static targets = [
    'clearButton',
    'searchbutton',
    'keywordInput',
    'formLimitValue',
  ];

  declare clearButtonTarget: HTMLButtonElement;
  declare searchbuttonTarget: HTMLButtonElement;
  declare formLimitValueTarget: HTMLInputElement;
  declare keywordInputTarget: HTMLInputElement;

  private readonly onLoadAdditionalResults = () => this.loadAdditionalResults();

  connect(): void {
    document.addEventListener(
      RESULTS_EVENTS.LOAD_ADDITIONAL_RESULTS,
      this.onLoadAdditionalResults
    );
    this.populateResults();
  }

  // The modal is reopened without a page load, so a listener left behind would
  // fire a search for every earlier connect.
  disconnect(): void {
    document.removeEventListener(
      RESULTS_EVENTS.LOAD_ADDITIONAL_RESULTS,
      this.onLoadAdditionalResults
    );
  }

  public submit(): void {
    this.searchbuttonTarget.click();
  }

  public keywordInputChange(): void {
    this.resetFormLimit();
  }

  public clearInput() {
    this.clearKeywordInput();
    this.populateResults();
  }

  private clearKeywordInput() {
    this.keywordInputTarget.value = '';
  }

  private populateResults() {
    this.submit();
  }

  private loadAdditionalResults() {
    this.increaseFormLimit();
    this.submit();
  }

  private increaseFormLimit() {
    const current = Number(this.formLimitValueTarget.value);
    this.formLimitValueTarget.value = String(current + LIMIT_INCREASE);
  }

  private resetFormLimit() {
    this.formLimitValueTarget.value = String(LIMIT_INCREASE);
  }
}
